import * as React from 'react';
import PropTypes from 'prop-types';

export default class UserListItem extends React.Component {
  toBoolean = (value) => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') {
      if (value === 1) return true;
      if (value === 0) return false;
    }
    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      if (['true', '1', 'si', 'sí', 'yes', 'activo', 'habilitado'].includes(normalized)) return true;
      if (['false', '0', 'no', 'inactivo', 'deshabilitado'].includes(normalized)) return false;
    }
    return undefined;
  };

  handleRowClick = (e) => {
      const { onRowClick } = this.props;
      if (typeof onRowClick !== 'function') return;
      onRowClick(e);
  };

  render = () => {
    const {
      id,
      nombreUsuario,
      email,
      baja,
      activo,
      estado,
      idEstado,
      onRowClick
    } = this.props;
    const parsedEstado = (estado || "").toString().trim().toLowerCase();
    const bajaBool = this.toBoolean(baja);
    const activoBool = this.toBoolean(activo);
    const parsedIdEstado = Number(idEstado);
    const isInactivo =
      (typeof bajaBool === 'boolean' && bajaBool) ||
      (typeof activoBool === 'boolean' && !activoBool) ||
      parsedEstado === 'inactivo' ||
      (Number.isFinite(parsedIdEstado) && parsedIdEstado > 1);
    const cardEstado = isInactivo ? 'admin-list-card--inactivo' : 'admin-list-card--vigente';

    return (
      <button
        className={`admin-list-card p-3 ${cardEstado} ${onRowClick ? 'cursor-pointer' : ''}`}
        onClick={this.handleRowClick}
      >
        <div className="row g-2 g-md-3 align-items-center">
          <div className="col-auto">
            <span className="admin-id-badge">{id}</span>
          </div>
          <div className="col-12 col-sm-5 col-md-4 col-lg-5">
            <div className="admin-list-card__title fw-semibold small mb-0 text-break">
              {nombreUsuario}
            </div>
          </div>
          <div className="col-12 col-sm d-flex flex-wrap align-items-center gap-2 justify-content-sm-end">
            <span className="small text-break mb-0">
              <i className="fas fa-envelope me-1 text-body-secondary" aria-hidden="true" />
              {email || '—'}
            </span>
            <span
              className={`admin-metric-pill ${isInactivo ? 'admin-status-pill admin-status-pill--inactivo' : 'admin-status-pill admin-status-pill--activo'}`}
              title={isInactivo ? 'Usuario inactivo' : 'Usuario activo'}
            >
              <i className={`fas ${isInactivo ? 'fa-user-slash' : 'fa-user-check'}`} aria-hidden="true" />
              {isInactivo ? 'Inactivo' : 'Activo'}
            </span>
          </div>
        </div>
      </button>
    );
  };
}
UserListItem.propTypes = {
    onRowClick: PropTypes.func,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    nombreUsuario: PropTypes.string,
    email: PropTypes.string,
    baja: PropTypes.bool,
}